import React from 'react';

import {
  Box,
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import {
  Control,
  Controller,
  FieldPath,
  FieldValues
} from 'react-hook-form';

import { ApprovalTypeName } from 'generated/graphql';



const LabelTypography = styled(Typography)(() => ({
  fontSize: 12,
  position: 'absolute',
  top: -20,
  color: 'rgba(0, 0, 0, 0.6)'
}));

const ContainerBox = styled(Box)(() => ({
  position: 'relative'
}));



export interface IControllerProps<TFormState extends FieldValues> {
  formControl: Control<TFormState>;
  fieldKey: FieldPath<TFormState>;
  isDisabled?: boolean;
  label?: string;
}

export function genComponentAndControllerGenerator() {
  function genController<TFormState extends FieldValues>() {
    const ToggleController: React.FC<IControllerProps<TFormState>> = props => {
      return (
        <Controller
          control={props.formControl}
          name={props.fieldKey}
          render={({ field }) => (
            <FC
              label={props.label}
              isDisabled={props.isDisabled}
              value={field.value}
              onChange={field.onChange} />
          )} />
      );
    };

    return ToggleController;
  }


  return {
    genController
  };
}



export interface IProps {
  label?: string;
  isDisabled?: boolean;

  value: ApprovalTypeName[];
  onChange: (value: ApprovalTypeName[]) => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <ContainerBox>
      <LabelTypography>
        {props.label}
      </LabelTypography>

      <ToggleButtonGroup
        size="small"
        value={props.value}
        onChange={(event, value) => {
          if (value) {
            props.onChange(value);
          }
        }}>
        <ToggleButton
          value="approved"
          color="primary">
          Approved
        </ToggleButton>

        <ToggleButton
          value="denied"
          color="primary">
          Denied
        </ToggleButton>

        <ToggleButton
          value="pending"
          color="primary">
          Pending
        </ToggleButton>
      </ToggleButtonGroup>
    </ContainerBox>
  );
};
